<div #container [innerHtml]="diffHtml">
</div>
